import type { SitecoreUserRatingDetailedCategory, UserReviewsScores } from '@/cms/fields/types/product-detail-page'
import type { IconGlyph } from '@sunwebgroup/ui-components'

export function getPartyCompositionType(partyCompositionId: string) {
  const typesIds: Record<string, string> = {
    11: 'type_alone',
    12: 'type_withpartner',
    13: 'type_friends',
    14: 'type_family',
    15: 'type_singleparent',
    16: 'type_group',
  }
  const typeId = partyCompositionId in typesIds ? typesIds[partyCompositionId] : 'type_unknown'

  return typeId
}

export function getScoreBarsType(reviewsData: UserReviewsScores[] | undefined) {
  const totalAmount = reviewsData?.reduce((acc, score) => acc + score.Amount, 0) || 1
  const scoreBarsData = reviewsData?.map((score) => {
    return {
      score: (score.Amount / totalAmount) * 100,
      typeId: score.Type,
    }
  })

  return scoreBarsData
}

export function getCategoriesData(ratingCategories: SitecoreUserRatingDetailedCategory[] | undefined) {
  const categoriesIconMap: Record<number, { icon: IconGlyph, order: number }> = {
    10: { icon: 'IconPopularVillage', order: 1 },
    20: { icon: 'IconTag', order: 2 },
    30: { icon: 'IconPinMap', order: 3 },
    40: { icon: 'IconBed2Persons', order: 4 },
    50: { icon: 'IconSpray', order: 5 },
    60: { icon: 'IconRoomservice', order: 6 },
    70: { icon: 'IconKids', order: 7 },
    100: { icon: 'IconAmenities', order: 8 },
  }
  const categoriesData = ratingCategories
    ?.map((category) => {
      return {
        icon: categoriesIconMap[category.Name]?.icon,
        order: categoriesIconMap[category.Name]?.order,
        score: category.Rating,
        typeId: category.Name,
      }
    })
    .sort((a, b) => a.order - b.order)

  return categoriesData
}
